export default "__VITE_ASSET__CJ6b_O2R__"